// 账号类型 1主账号 2子账号
export enum AccountType {
  Main = 1,
  Sub = 2,
}

export enum HaveSubAccount {
  No = 0,
  Yes = 1,
}

// 账号类型 0普通子账号或者主账号，1钉钉子账号
export enum DingTalkAccountType {
  No,
  Yes,
}

// 是否是学生账号 0未验证 1验证中 2已通过 3已驳回
export enum InfoStatus {
  NotVerified = 0,
  Verifying = 1,
  Passed = 2,
  Rejected = 3,
  Expired = 4,
}

// 隐藏余额 0关 1开
export enum HideBalance {
  Close = 0,
  Open = 1,
}

// 隐藏子账号作业扣费 0关 1开
export enum HideJobCharge {
  Close = 0,
  Open = 1,
}

// 允许调整作业优先级
export enum GroupTaskLevel {
  Close = 0,
  Open = 1,
}

// 业务类型 0效果图 1动画 3大雁云 4Beta
export enum BusinessType {
  Picture = 0,
  Animation = 1,
  Dayan = 3,
  Beta = 4,
}

// 后管开关子账号功能 0关 1开
export enum DisplaySubaccount {
  Close = 0,
  Open = 1,
}

// 国内外区域 1国内 2国外
export enum Zone {
  Domestic = 1,
  Foreign = 2,
}

// 效果图会员 0非会员 1会员
export enum PictureLever {
  Normal = 0,
  Member = 1,
}

// 软件选择 0未选择 1已选择
export enum SoftStatus {
  UnSelect = 0,
  Selected = 1,
}

// 共用主账号资产 0不共用 1共用
export enum ShareMainCapital {
  Close = 0,
  Open = 1,
}

// 允许子账号删除任务 0不允许 1允许
export enum SubDeleteTask {
  Close = 0,
  Open = 1,
}

// 允许子账号删除资产  0不允许 1允许
export enum SubDeleteCapital {
  Close = 0,
  Open = 1,
}

// 登录或注册类型
export enum LoginType {
  NotLogin,
  QQ,
  WeChat,
  UserName,
  Email,
  Phone,
  Google,
}
// 认证状态
export enum AuthStatus {
  NoCertified,
  PersonUnderReview,
  EnterpriseUnderReview,
  PersonalAuthFailed,
  PendingReview,
  Changing,
  PersonalAuthSuccess,
  EnterpriseAuthSuccess,
  EnterpriseAuthFail,
  PersonaChangeFailed,
  EnterpriseChangeFailed,
  PersonalToEnterpriseFailed,
  PersonalChanging,
}
export const UserCertifiedStatus = [
  AuthStatus.PersonalAuthSuccess,
  AuthStatus.EnterpriseAuthSuccess,
  AuthStatus.Changing,
  AuthStatus.EnterpriseChangeFailed,
  AuthStatus.PersonalChanging,
  AuthStatus.PersonalToEnterpriseFailed,
  AuthStatus.PersonaChangeFailed,
];
// 用户类型 1个人用户 2企业用户
export enum UserType {
  Personal = 1,
  Business = 2,
}

// 用户等级
export enum UserLevel {
  Normal = 49,
  Sliver = 55,
  Gold = 56,
  Platinum = 57,
  Diamond = 58,
  DiamondStudent = 59,
  DiamondAnimationGift = 60,
  PictureNormal = 0,
  PictureVip = 1,
}

// 用户认证权限状态
export enum UserAuthStatus {
  Certified, // 已认证
  OLD, // 时间小于设置的延迟认证时间,可提交作业，需提示
  NEW, // 未实名（新用户或老用户超出延迟认证时间后），不能提交作业
}

// 手机号人工审核状态  0审核中，1审核通过，2审核失败, 3撤销
export enum PhoneAppealState {
  UnderReview = 0,
  Success = 1,
  Failed = 2,
  Cancel = 3,
}

export enum MemberRechargeStatus {
  None = 0,
  Paid = 1,
}

export enum Terminal {
  Office = 1,
  Task,
}

/** 渲染费用 */
export enum FeeTitle {
  Cash = 1 /** 现金 */,
  Coupon /** 2消费券 */,
}

export enum AuthStatus {
  Uncertified = 0,
  Checking,
  Passed,
  Failure,
  WaitForCheck,
  Refused,
}

export enum Whether {
  No,
  Yes,
}
